import { useState } from 'react';
import { Button } from '~/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/components/ui/dialog';
import { Kbd, KbdGroup } from '~/components/ui/kbd';
import { SHORTCUTS, type ShortcutDef } from './registry';
import { useShortcut } from './useShortcut';

const VISIBLE_SHORTCUTS = Object.entries(SHORTCUTS).filter(
  ([, d]) => !(d as ShortcutDef).hideInHelp,
);

function ShortcutKeys({ keys }: { keys: string }) {
  const parts = keys.split('+');
  return (
    <KbdGroup>
      {parts.map((part, i) => (
        <span key={part} className="contents">
          {i > 0 && <span className="text-muted-foreground">+</span>}
          <Kbd>{part}</Kbd>
        </span>
      ))}
    </KbdGroup>
  );
}

export function ShortcutsHelp() {
  const [open, setOpen] = useState(false);
  useShortcut('openHelp', () => setOpen(true));

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" aria-label="Keyboard shortcuts">
          ?
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
        </DialogHeader>
        <ul className="space-y-2 text-sm">
          {VISIBLE_SHORTCUTS.map(([id, d]) => (
            <li key={id} className="flex items-center justify-between gap-3">
              <span>{d.label}</span>
              <ShortcutKeys keys={d.keys} />
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
